// extracted by mini-css-extract-plugin
module.exports = {"loaderDiv":"Loader_loaderDiv__1Ay_o","loader":"Loader_loader__2hZcM","spin":"Loader_spin__1X-nh"};